var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24HourgleassHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-hourgleass_half",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M13.5,20H.5a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,.5,18H1V15A2.982,2.982,0,0,1,2.13,12.62L5.4,10,2.13,7.38A3.022,3.022,0,0,1,1,5V2H.5A.5.5,0,0,1,0,1.5V.5A.5.5,0,0,1,.5,0h13a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H13V5A2.98,2.98,0,0,1,11.87,7.38L8.6,10l3.27,2.66A2.984,2.984,0,0,1,13,15v3h.5a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,13.5,20ZM7,11.28H7L3.38,14.22A1,1,0,0,0,3,15v1h8V15a1,1,0,0,0-.38-.82L7,11.28ZM3,2V5h8V2Z",
    transform: "translate(5 2)",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24HourgleassHalf);
export default __webpack_public_path__ + "static/media/icon-24-hourgleass_half.4724acbb3377bdeceaa1ac7bf30fa09e.svg";
export { ForwardRef as ReactComponent };